module.exports = __webpack_public_path__ + "img/massage.81482034.png";